(function (window, document) {
  'use strict';

  var MINT_DIRECT_STORE_ID = 'mint_direct';
  var NO_STORE_NEARBY_STORE_ID = 'no_store_nearby';
  function isMintDirectStore(id) {
    return String(id) === MINT_DIRECT_STORE_ID;
  }
  function isNoStoreNearby(id) {
    return String(id) === NO_STORE_NEARBY_STORE_ID;
  }

  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  function dateLocale() {
    var lc = (window.buybackPortal && window.buybackPortal.locale) || 'fr';
    return lc === 'en' ? 'en-GB' : 'fr-FR';
  }

  // Aligne LIST et PROGRESS sur un label canonique : l'override pointe vers une
  // clé i18n (statuses_*) pour rester localisé. Sans ce mapping, LIST tomberait
  // sur le label backend brut qui peut diverger du libellé souhaité côté UI portail
  // (cf. locales/*.json — clé buyback_portal.statuses.*).
  var STATUS_LABEL_OVERRIDE_KEYS = {
    nouveau: 'statuses_analyse_velo',
    demande_deposee: 'statuses_analyse_velo',
    analyse_velo: 'statuses_analyse_velo',
    'Analyse du vélo': 'statuses_analyse_velo',
    en_cours_negociation: 'statuses_offre_emise',
    offre_emise: 'statuses_offre_emise',
    contractualisation: 'statuses_contractualisation',
    transport_programme: 'statuses_transport_programme',
    recu_a_verifier: 'statuses_recu_a_verifier',
    velo_paye: 'statuses_velo_paye',
    velo_recu_paye: 'statuses_velo_paye',
    paiement_emis: 'statuses_velo_paye',
  };
  function normalizeStepLabel(rawLabel, slug) {
    var i18n = window.buybackPortalI18n || {};
    var key = (slug && STATUS_LABEL_OVERRIDE_KEYS[slug]) || (rawLabel && STATUS_LABEL_OVERRIDE_KEYS[rawLabel]);
    if (key && i18n[key]) return i18n[key];
    return rawLabel || '';
  }

  // Source canonique du label "étape courante" partagée entre LIST et PROGRESS :
  // 1) timeline.steps + step.current → label localisé via normalizeStepLabel
  // 2) sinon fallback sur status_slug via STATUS_LABEL_OVERRIDE_KEYS
  // 3) sinon statuses_unknown (i18n) ou 'Statut inconnu'
  // Note : le cas 'refused' reste géré inline par les appelants (logique
  // proposition vs demande différenciée — non couvert ici).
  function resolveCurrentStepLabel(reprise) {
    var i18n = window.buybackPortalI18n || {};
    var steps = reprise && reprise.timeline && Array.isArray(reprise.timeline.steps) ? reprise.timeline.steps : [];
    var current = null;
    for (var i = 0; i < steps.length; i++) {
      if (steps[i] && steps[i].current) {
        current = steps[i];
        break;
      }
    }
    if (current) {
      var slug = current.slug || current.key || current.id;
      var raw = current.label || '';
      // Si le backend renvoie un slug brut "EN_COURS_NEGOCIATION", normalise en minuscules.
      if (/^[A-Z_]+$/.test(raw)) raw = raw.toLowerCase();
      var resolved = normalizeStepLabel(raw, slug);
      if (resolved) return resolved;
    }
    var fallbackSlug = (reprise && (reprise.status_slug || reprise.status)) || '';
    if (typeof fallbackSlug === 'object' && fallbackSlug && fallbackSlug.slug) fallbackSlug = fallbackSlug.slug;
    var key = STATUS_LABEL_OVERRIDE_KEYS[fallbackSlug];
    if (key && i18n[key]) return i18n[key];
    // Dégrade gracieusement un slug non mappé en label lisible (ex
    // "en_cours_negociation" → "En cours negociation") plutôt qu'un brut
    // "Statut inconnu", qui sert de filet de secours pour les cas vides.
    if (fallbackSlug) {
      var spaced = String(fallbackSlug).toLowerCase().replace(/_/g, ' ');
      return spaced.charAt(0).toUpperCase() + spaced.slice(1);
    }
    return i18n.statuses_unknown || 'Statut inconnu';
  }

  // États UI possibles : 'pending' | 'emitted' | 'contractualisation' | 'transport' | 'received' | 'paid' | 'refused'
  function computeStateFromSlug(slug /* , substep */) {
    var s = slug || '';
    if (s === 'nouveau' || s === 'demande_deposee' || s === 'analyse_velo') return 'pending';
    if (s === 'offre_emise' || s === 'en_cours_negociation') return 'emitted';
    if (s === 'demande_refusee' || s === 'proposition_refusee' || s === 'proposition_expiree') return 'refused';
    if (s === 'contractualisation') return 'contractualisation';
    if (s === 'transport_programme') return 'transport';
    if (s === 'recu_a_verifier') return 'received';
    if (s === 'velo_recu_paye' || s === 'velo_paye' || s === 'paiement_emis') return 'paid';
    return 'pending';
  }

  function normalizeLabel(label) {
    var s = String(label || '').toLowerCase();
    try {
      s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    } catch (e) {}
    return s;
  }

  function stateFromLabel(label) {
    var s = normalizeLabel(label);
    if (!s) return null;
    if (s.indexOf('transport') !== -1) return 'transport';
    if (s.indexOf('receptionne') !== -1 || s.indexOf('received') !== -1 || s.indexOf('recu') !== -1) return 'received';
    if (s.indexOf('paye') !== -1 || s.indexOf('paid') !== -1) return 'paid';
    if (s.indexOf('contractualisation') !== -1) return 'contractualisation';
    if (s.indexOf('offre') !== -1 || s.indexOf('offer') !== -1) return 'emitted';
    if (s.indexOf('analyse') !== -1 || s.indexOf('depose') !== -1 || s.indexOf('deposit') !== -1) return 'pending';
    return null;
  }

  function stepToState(step, substep) {
    if (!step) return null;
    var slug = step.slug || step.key || step.id;
    if (slug) return computeStateFromSlug(slug, substep);
    return stateFromLabel(step.label);
  }

  // Source de vérité = `reprise.timeline`. Ordre de priorité :
  //   1. refused → 'refused'
  //   2. step `current: true` → state dérivé de son slug/label
  //   3. dernière step `completed: true` (back qui omet current alors que tout est complété)
  //   4. fallback `status_slug`
  function computeStateFromTimeline(reprise, fallbackSlug, substep) {
    if (reprise && reprise.timeline && reprise.timeline.refused) return 'refused';
    var steps = reprise && reprise.timeline && Array.isArray(reprise.timeline.steps) ? reprise.timeline.steps : [];

    var currentStep = steps.find(function (s) {
      return s && s.current;
    });
    var fromCurrent = stepToState(currentStep, substep);
    if (fromCurrent) return fromCurrent;

    var lastCompleted = null;
    for (var i = steps.length - 1; i >= 0; i--) {
      if (steps[i] && steps[i].completed) {
        lastCompleted = steps[i];
        break;
      }
    }
    var fromCompleted = stepToState(lastCompleted, substep);
    if (fromCompleted) return fromCompleted;

    return computeStateFromSlug(fallbackSlug || '', substep);
  }

  function buildBikeLabel(bike) {
    var bikeLabel = '';
    if (bike.brand || bike.model) {
      bikeLabel = (bike.brand || '') + ' ' + (bike.model || '');
      if (bike.year || bike.kilometrage) {
        bikeLabel += ' (' + (bike.year || '') + (bike.kilometrage ? ' | ' + bike.kilometrage + ' km' : '') + ')';
      }
    }
    return bikeLabel.trim();
  }

  function hasStoreChosen(reprise) {
    // Backend = seule source de vérité (boutique_hubspot_id présent dans le payload).
    return !!(reprise && reprise.boutique_hubspot_id);
  }

  function getTimelineSteps(reprise) {
    var timeline = reprise && reprise.timeline;
    if (timeline && Array.isArray(timeline.steps) && timeline.steps.length > 0) return timeline.steps;
    try {
      console.warn('[buyback] reprise.timeline.steps absent — fallback minimal');
    } catch (e) {}
    // Fallback dynamique sur le status_slug réel pour éviter d'afficher
    // "Analyse du vélo" alors que la reprise est en transport ou contractualisation.
    return [{ label: resolveCurrentStepLabel(reprise), completed: false, current: true, date: null }];
  }

  function renderProgress(root, reprise, state) {
    var progressEl = root.querySelector('[data-bp-progress]');
    var labelEl = root.querySelector('[data-bp-current-step-label]');
    var counterEl = root.querySelector('[data-bp-step-counter]');
    var fillEl = root.querySelector('[data-bp-progress-fill]');

    if (state === 'refused') {
      if (progressEl) progressEl.setAttribute('data-bp-progress-state', 'refused');
      var slug = (reprise && reprise.status_slug) || '';
      var refusedKey;
      if (slug === 'proposition_expiree') {
        refusedKey = 'progress_expired_proposition_label';
      } else if (slug === 'proposition_refusee') {
        refusedKey = 'progress_refused_proposition_label';
      } else {
        refusedKey = 'progress_refused_demande_label';
      }
      if (labelEl) labelEl.textContent = t(refusedKey);
      if (counterEl) counterEl.hidden = true;
      if (fillEl) fillEl.style.width = '100%';
      return;
    }

    // Reset entre re-rendus (state passe de 'refused' à autre chose)
    if (progressEl) progressEl.removeAttribute('data-bp-progress-state');
    if (counterEl) counterEl.hidden = false;

    var steps = getTimelineSteps(reprise);
    var total = steps.length;
    var currentIndex = steps.findIndex(function (s) {
      return s && s.current;
    });
    if (currentIndex === -1) currentIndex = total - 1;
    var displayedNum = currentIndex + 1;
    var currentStep = steps[currentIndex];
    var rawCurrentLabel = (currentStep && currentStep.label) || '';
    var currentSlug = currentStep && (currentStep.slug || currentStep.key || currentStep.id);
    if (labelEl) labelEl.textContent = normalizeStepLabel(rawCurrentLabel, currentSlug);
    if (counterEl) counterEl.textContent = displayedNum + '/' + total;
    if (fillEl) fillEl.style.width = (displayedNum / total) * 100 + '%';
  }

  function parseRefusalMotif(timelineRefused) {
    if (!timelineRefused || typeof timelineRefused.motif !== 'string') return { predef: '', text: '' };
    var raw = timelineRefused.motif;
    var sepIdx = raw.indexOf(': ');
    if (sepIdx > 0) {
      return { predef: raw.slice(0, sepIdx), text: raw.slice(sepIdx + 2) };
    }
    return { predef: raw, text: '' };
  }

  // Résout le libellé d'un motif. Priorité aux motifs système (`refused_motif_*` —
  // ex auto_refusal_7d) ; sinon fallback sur les motifs clients de la modal refuse
  // (`modal_refuse_reasons_*`). Retourne le predef brut si aucune traduction.
  function getMotifLabel(predef) {
    if (!predef) return '';
    var systemKey = 'refused_motif_' + predef;
    var systemLabel = t(systemKey);
    if (systemLabel && systemLabel !== systemKey) return systemLabel;
    var clientKey = 'modal_refuse_reasons_' + predef;
    var clientLabel = t(clientKey);
    if (clientLabel && clientLabel !== clientKey) return clientLabel;
    return predef;
  }

  function renderOffer(root, reprise, substep, state) {
    var card = root.querySelector('[data-bp-offer-card]');
    if (!card) return;
    var offer = reprise.offer || {};
    var bike = reprise.bike || {};
    var bikeEl = root.querySelector('[data-bp-offer-bike]');
    var priceEl = root.querySelector('[data-bp-offer-price]');
    var priceSubEl = root.querySelector('[data-bp-offer-price-subtitle]');
    var pendingEl = root.querySelector('[data-bp-offer-pending]');
    var refusedEl = root.querySelector('[data-bp-offer-refused]');
    var validityEl = root.querySelector('[data-bp-offer-validity]');
    var introEl = root.querySelector('[data-bp-offer-intro]');
    var accept = root.querySelector('[data-bp-accept]');
    var refuse = root.querySelector('[data-bp-refuse]');
    var pickStore = root.querySelector('[data-bp-pick-store]');
    var uploadDocs = root.querySelector('[data-bp-upload-docs]');
    var showCalc = root.querySelector('[data-bp-show-calc]');

    if (bikeEl) bikeEl.textContent = buildBikeLabel(bike) || '—';
    var hasPrice = offer.price !== null && offer.price !== undefined && offer.price !== '';
    if (priceEl) priceEl.textContent = hasPrice ? offer.price + ' €' : '—';
    if (priceSubEl) priceSubEl.hidden = !hasPrice;

    var isPaid = state === 'paid';
    var isRefused = state === 'refused';
    if (pendingEl) pendingEl.hidden = hasPrice || isRefused;
    if (refusedEl) refusedEl.hidden = !isRefused;
    var reasonEl = root.querySelector('[data-bp-offer-refused-reason]');
    if (reasonEl) {
      var hasReason = false;
      if (isRefused) {
        var refusal = parseRefusalMotif(reprise.timeline && reprise.timeline.refused);
        var label = '';
        if (refusal.predef === 'autre' && refusal.text) {
          label = refusal.text;
        } else if (refusal.predef) {
          label = getMotifLabel(refusal.predef);
          // Les motifs système (préfixe `auto_`) ne doivent jamais concaténer
          // de texte additionnel : leur libellé est self-contained et tout
          // suffixe risque d'exposer un log interne ERP côté utilisateur.
          var isSystemMotif = refusal.predef.indexOf('auto_') === 0;
          if (refusal.text && !isSystemMotif) label += ' — ' + refusal.text;
        } else if (refusal.text) {
          label = refusal.text;
        }
        if (label) {
          var prefix = t('offer_refused_reason_prefix') || 'Motif renseigné :';
          reasonEl.textContent = prefix + ' ' + label;
          hasReason = true;
        }
      }
      reasonEl.hidden = !hasReason;
    }

    if (isRefused) {
      var refusedSlug = (reprise && (reprise.status_slug || reprise.status)) || '';
      var isExpired = refusedSlug === 'proposition_expiree';
      var labelEl = root.querySelector('.bp-offer-card__refused-label');
      var subtitleEl = root.querySelector('.bp-offer-card__refused-subtitle');
      if (labelEl) labelEl.textContent = t(isExpired ? 'offer_expired_label' : 'offer_refused_label');
      if (subtitleEl) subtitleEl.textContent = t(isExpired ? 'offer_expired_subtitle' : 'offer_refused_subtitle');
      var refusedCta = root.querySelector('[data-bp-offer-refused-cta]');
      if (refusedCta) {
        var cfg = window.buybackPortalConfig;
        if (cfg && typeof cfg.getSellBikeUrl === 'function') {
          refusedCta.href = cfg.getSellBikeUrl();
        }
      }
    }
    if (validityEl) {
      if (offer.deadline && hasPrice && !isPaid && !isRefused) {
        var tpl = t('offer_deadline_format') || 'Offre finale · valable jusqu’au {{ date }}';
        validityEl.textContent = tpl.replace('{{ date }}', new Date(offer.deadline).toLocaleDateString(dateLocale()));
        validityEl.hidden = false;
      } else {
        validityEl.hidden = true;
        validityEl.textContent = '';
      }
    }

    var uiState = !hasPrice && !isPaid && !isRefused ? 'pending' : state;
    card.setAttribute('data-bp-offer-state', uiState);

    // Step 7 "Vélo payé" : masquer tous CTAs/recap/calc — seuls prix + libellé subsistent.
    var canDecide = state === 'emitted' && hasPrice && !offer.accepted && !offer.refused;
    if (accept) accept.hidden = !canDecide || isPaid || isRefused;
    if (refuse) refuse.hidden = !canDecide || isPaid || isRefused;
    if (pickStore) {
      // Différencie PART vs non-PART : PART choisit une boutique, non-PART
      // programme une date d'enlèvement. Même bouton DOM, label adapté.
      // Action conservée (data-bp-pick-store) — `_onPickStoreClick` détecte
      // le vendor_type et redirige vers `_openPickupDateFlow` si non-PART.
      var part = isPart(reprise, window.__buybackMe || null);
      var showPick = state === 'contractualisation' && substep === 'none';
      if (part) {
        showPick = showPick && !hasStoreChosen(reprise);
        pickStore.textContent = t('offer_store_cta') || 'Choisir la boutique de dépôt →';
      } else {
        showPick = showPick && !reprise.pickup_requested_date;
        pickStore.textContent = t('offer_pickup_date_cta') || 'Choisir la date d’enlèvement →';
      }
      pickStore.hidden = !showPick || isPaid || isRefused;
    }
    if (uploadDocs) {
      var showUpload = state === 'contractualisation' && substep === 'store_chosen';
      uploadDocs.hidden = !showUpload || isPaid || isRefused;
    }
    // Banner 24h (contractualisation, avant docs uploadés) — wording adapté PART vs NON-PART
    // Banner 24h visible UNIQUEMENT quand le CTA "upload docs" est lui-même visible :
    // contractualisation + substep === 'store_chosen' (= boutique PART choisie OU
    // date NON-PART confirmée, mais docs pas encore uploadés).
    // AMENDMENT A7 (N5): meReady guard — masque tant que /me n'est pas chargée
    // pour éviter le FOUC "contrat" sur NON-PART (isPart fallback PART sans me).
    var banner24h = root.querySelector('[data-bp-banner-24h]');
    if (banner24h) {
      var meReady = !!window.__buybackMe;
      var show24h = meReady && state === 'contractualisation' && substep === 'store_chosen' && !isPaid && !isRefused;
      banner24h.hidden = !show24h;
      if (show24h) {
        var isPartReprise = isPart(reprise, window.__buybackMe);
        var titleKey = isPartReprise ? 'offer_banner_24h_contract_title' : 'offer_banner_24h_invoice_title';
        var titleEl = banner24h.querySelector('[data-bp-banner-24h-title]');
        if (titleEl) {
          var titleTxt = t(titleKey);
          if (titleTxt && titleTxt !== titleKey) titleEl.textContent = titleTxt;
        }
      }
    }
    if (showCalc) showCalc.hidden = !hasPrice || isPaid || isRefused;

    if (introEl) {
      if (state === 'emitted' && hasPrice) {
        var introTpl = t('offer_intro_template');
        if (!introTpl || introTpl === 'offer_intro_template') introEl.textContent = '';
        else introEl.textContent = introTpl.replace('{{ brand }}', bike.brand || '').replace(/\s+!/, ' !');
      } else {
        introEl.textContent = '';
      }
    }
  }

  // Ordre canonique des jours pour l'accordion store-card.
  var STORE_CARD_DAY_KEYS = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
  var STORE_CARD_DAY_LABELS = {
    lundi: 'Lundi',
    mardi: 'Mardi',
    mercredi: 'Mercredi',
    jeudi: 'Jeudi',
    vendredi: 'Vendredi',
    samedi: 'Samedi',
    dimanche: 'Dimanche',
  };

  function parseStoreHours(raw) {
    if (!raw) return null;
    try {
      var once = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return typeof once === 'string' ? JSON.parse(once) : once;
    } catch (e) {
      return null;
    }
  }

  function formatStoreAddress(raw) {
    if (!raw || typeof raw !== 'object') return '';
    var parts = [];
    if (raw.address) parts.push(String(raw.address));
    var line2 = [String(raw.zip || '').trim(), String(raw.city || '').trim()].filter(Boolean).join(' ');
    if (line2) parts.push(line2);
    return parts.join(', ');
  }

  function formatStoreHoursDay(dayData) {
    if (!dayData || dayData.closed) return t('modal_store_closed') || 'Fermé';
    var slots = (dayData.slots || [])
      .map(function (s) {
        var open = String((s && s.open) || '').replace(':', 'h');
        var close = String((s && s.close) || '').replace(':', 'h');
        if (!open && !close) return '';
        return open + '–' + close;
      })
      .filter(Boolean);
    if (!slots.length) return t('modal_store_closed') || 'Fermé';
    return slots.join(', ');
  }

  // Retourne { name, address, hours } pour un storeId donné. Centralise la
  // lecture du script `[data-bp-stores]` pour éviter de re-parser à chaque
  // hydratation et factorise la branche `mint_direct`. `lookupStoreName`
  // reste exposé en alias (utilisé par list-actions et tests externes).
  function lookupStore(storeId) {
    var empty = { name: '', address: '', hours: null };
    if (isNoStoreNearby(storeId)) {
      return {
        name: t('modal_store_method_no_store_nearby_name') || '',
        address: '',
        hours: null,
      };
    }
    if (!storeId) return empty;
    if (isMintDirectStore(storeId)) {
      return {
        name: t('modal_store_method_mint_direct_name') || '',
        address: t('modal_store_method_mint_direct_description') || '',
        hours: null,
      };
    }
    var script = document.querySelector('[data-bp-stores]');
    if (!script) return empty;
    var raw = (script.textContent || '').trim();
    if (!raw) return empty;
    var parsed = null;
    try {
      parsed = JSON.parse(raw);
      if (typeof parsed === 'string') parsed = JSON.parse(parsed); // double-encodé
    } catch (e) {
      return empty;
    }
    if (!Array.isArray(parsed)) return empty;
    var found = parsed.find(function (s) {
      return String(s.id) === String(storeId);
    });
    if (!found) return empty;
    return {
      name: found.name || '',
      address: formatStoreAddress(found),
      hours: parseStoreHours(found.horaires),
    };
  }

  function lookupStoreName(storeId) {
    return lookupStore(storeId).name;
  }

  // Construit la liste des horaires via DOM API (textContent) au lieu d'une
  // concaténation HTML : `s.open`/`s.close` proviennent du JSON `[data-bp-stores]`
  // qui transite par Shopify metaobject ; on évite tout risque XSS si une
  // valeur contient un caractère HTML (`<`, `&`, etc.).
  function appendStoreHoursLis(ulEl, hours) {
    STORE_CARD_DAY_KEYS.forEach(function (key) {
      var li = document.createElement('li');
      var daySpan = document.createElement('span');
      daySpan.className = 'bp-offer-card__selection-hours-day';
      daySpan.textContent = STORE_CARD_DAY_LABELS[key] || key;
      var slotsSpan = document.createElement('span');
      slotsSpan.className = 'bp-offer-card__selection-hours-slots';
      slotsSpan.textContent = formatStoreHoursDay(hours[key]);
      li.appendChild(daySpan);
      li.appendChild(slotsSpan);
      ulEl.appendChild(li);
    });
  }

  var _pickupDateFmt = null;
  var _pickupDateFmtLocale = null;
  function _getPickupDateFmt() {
    var loc = dateLocale();
    if (!_pickupDateFmt || _pickupDateFmtLocale !== loc) {
      try {
        _pickupDateFmt = new Intl.DateTimeFormat(loc, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
        _pickupDateFmtLocale = loc;
      } catch (e) {
        _pickupDateFmt = null;
      }
    }
    return _pickupDateFmt;
  }

  function formatPickupDateLong(isoDate) {
    if (!isoDate) return '';
    try {
      var parts = String(isoDate).split('-');
      if (parts.length === 3) {
        var d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        var fmt = _getPickupDateFmt();
        if (fmt && !isNaN(d.getTime())) return fmt.format(d);
      }
    } catch (e) {
      /* fallback raw */
    }
    return String(isoDate);
  }

  function formatPickupDateShort(isoDate) {
    if (!isoDate) return '';
    try {
      var parts = String(isoDate).split('-');
      if (parts.length === 3) {
        var d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        if (!isNaN(d.getTime())) {
          return d.toLocaleDateString(dateLocale(), { day: 'numeric', month: 'long' });
        }
      }
    } catch (e) {
      /* fallback raw */
    }
    return String(isoDate);
  }

  // Hydrate le bloc collapsible `bp-offer-card__selection` au-dessus des CTAs.
  // PART : si boutique_hubspot_id présent → icon ✓, label = store name, address+horaires
  //        visibles dans details, bouton "Modifier le dépôt" (data-action="store-modify").
  // non-PART : si pickup_requested_date présent → icon 📅, label = "Enlèvement le {{date}}"
  //        (date courte), date longue dans details, bouton "Modifier la date"
  //        (data-action="pickup-modify"). address-block masqué.
  // Caché si state final (paid/refused) ou substep === 'none' ou data manquante.
  // Note : si reprise.boutique_hubspot_id présent mais vendor_type non-PART
  // (incohérence backend), le vendor_type prime → branche non-PART (donc masqué
  // tant que pickup_requested_date est null).
  function renderOfferCardSelection(root, reprise, me, substep, state) {
    var wrap = root.querySelector('[data-bp-selection]');
    if (!wrap) return;
    var isFinal = state === 'paid' || state === 'refused';
    if (isFinal || substep === 'none') {
      wrap.hidden = true;
      return;
    }
    var iconEl = wrap.querySelector('[data-bp-selection-icon]');
    var labelEl = wrap.querySelector('[data-bp-selection-label]');
    var detailsEl = wrap.querySelector('[data-bp-selection-details]');
    var addressBlock = wrap.querySelector('[data-bp-selection-address-block]');
    var addressEl = wrap.querySelector('[data-bp-selection-address]');
    var hoursEl = wrap.querySelector('[data-bp-selection-hours]');
    var dateLongEl = wrap.querySelector('[data-bp-selection-date-long]');
    var modifyBtn = wrap.querySelector('[data-bp-selection-modify]');
    var toggle = wrap.querySelector('[data-bp-selection-toggle]');

    // Reset toujours rétracté entre re-renders (polling notamment).
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (detailsEl) detailsEl.hidden = true;

    var part = isPart(reprise, me);
    if (part) {
      var storeId = reprise && reprise.boutique_hubspot_id;
      if (!storeId) {
        wrap.hidden = true;
        return;
      }
      var info = lookupStore(storeId);
      var isMint = isMintDirectStore(storeId);
      wrap.hidden = false;
      if (iconEl) iconEl.textContent = '✓';
      if (labelEl) labelEl.textContent = info.name || '—';
      if (addressBlock) addressBlock.hidden = false;
      if (addressEl) addressEl.textContent = info.address || '';
      if (hoursEl) {
        hoursEl.textContent = '';
        if (isMint || !info.hours) {
          hoursEl.hidden = true;
        } else {
          hoursEl.hidden = false;
          appendStoreHoursLis(hoursEl, info.hours);
        }
      }
      if (dateLongEl) {
        dateLongEl.hidden = true;
        dateLongEl.textContent = '';
      }
      if (modifyBtn) {
        modifyBtn.textContent = t('offer_selection_modify_store') || 'Modifier le dépôt';
        modifyBtn.setAttribute('data-action', 'store-modify');
      }
      return;
    }

    // non-PART
    var date = reprise && reprise.pickup_requested_date;
    if (!date) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    var shortDate = formatPickupDateShort(date);
    var longDate = formatPickupDateLong(date);
    if (iconEl) iconEl.textContent = '📅';
    if (labelEl) {
      var slot = reprise && reprise.pickup_requested_slot;
      if (slot) {
        var tplWithSlot = t('offer_selection_pickup_short_with_slot') || 'Enlèvement le {{ date }} ({{ slot }})';
        labelEl.textContent = tplWithSlot
          .replace('{{ date }}', shortDate)
          .replace('{{ slot }}', formatPickupSlot(slot));
      } else {
        var tpl = t('offer_selection_pickup_short') || 'Enlèvement le {{ date }}';
        labelEl.textContent = tpl.replace('{{ date }}', shortDate);
      }
    }
    if (addressBlock) addressBlock.hidden = true;
    if (addressEl) addressEl.textContent = '';
    if (hoursEl) {
      hoursEl.textContent = '';
      hoursEl.hidden = true;
    }
    if (dateLongEl) {
      dateLongEl.hidden = false;
      dateLongEl.textContent = longDate;
    }
    if (modifyBtn) {
      modifyBtn.textContent = t('offer_selection_modify_pickup') || 'Modifier la date';
      modifyBtn.setAttribute('data-action', 'pickup-modify');
    }
  }

  function renderStepMessage(root, state, substep) {
    var box = root.querySelector('[data-bp-step-message]');
    if (!box) return;
    var variant = null;
    if (state === 'transport') variant = 'transport';
    else if (state === 'received') variant = 'received';
    else if (state === 'contractualisation' && substep === 'docs_uploaded') variant = 'docs_uploaded';
    if (!variant) {
      box.hidden = true;
      box.removeAttribute('data-bp-step-message-state');
      return;
    }
    box.setAttribute('data-bp-step-message-state', variant);
    var titleEl = box.querySelector('[data-bp-step-message-title]');
    var subEl = box.querySelector('[data-bp-step-message-subtitle]');
    if (titleEl) titleEl.textContent = t('step_message_' + variant + '_title') || '';
    if (subEl) subEl.textContent = t('step_message_' + variant + '_subtitle') || '';
    box.hidden = false;
  }

  function parseJsonScript(node) {
    if (!node) return null;
    var raw = (node.textContent || '').trim();
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (typeof parsed === 'string') parsed = JSON.parse(parsed); // double-encodé
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function parseStores(/* root */) {
    var parsed = parseJsonScript(document.querySelector('[data-bp-stores]'));
    return Array.isArray(parsed) ? parsed : [];
  }

  function normalizeVendorType(reprise, me) {
    var rv = reprise && reprise.vendor_type;
    if (rv === 'PART') return 'PART';
    if (rv === 'VEL' || rv === 'LOU' || rv === 'LLD' || rv === 'FAB') return 'NON_PART';
    // /me peut retourner soit `{ vendorType, ... }` (plat) soit `{ user: { vendorType }, ... }`
    // (imbriqué). Sans le double accès, les non-PART en liste tombaient sur le
    // fallback PART → action rapide "Choisir la boutique" au lieu de
    // "Choisir la date d'enlèvement".
    var mv = (me && me.vendorType) || (me && me.user && me.user.vendorType) || null;
    if (mv === 'PRO' || mv === 'NON_PART' || mv === 'VEL' || mv === 'LOU' || mv === 'LLD' || mv === 'FAB') {
      return 'NON_PART';
    }
    return 'PART';
  }
  function isPart(reprise, me) {
    return normalizeVendorType(reprise, me) === 'PART';
  }

  // Factorise le mapping err → showError(...) pour la modal pickup-date, partagé
  // entre detail.js (`_openPickupDateFlow`) et list-actions.js (`doPickPickupDate`).
  // `ctx` = handle modal (`close`, `showError`). `callbacks` (toutes optionnelles) :
  //   - onRefresh : appelée après close pour rafraîchir la donnée (refetch détail ou liste)
  //   - onForbiddenForPart : appelée après onRefresh (HTTP_400+forbidden_for_part)
  //   - onStaleData : appelée après onRefresh (HTTP_409 / stale_data)
  function handlePickupDateError(err, ctx, callbacks) {
    var cbs = callbacks || {};
    var msg = (err && err.message) || '';
    var code = (err && err.code) || '';
    var detail = (err && err.detail) || '';
    var showError = ctx && typeof ctx.showError === 'function' ? ctx.showError : null;
    var close = ctx && typeof ctx.close === 'function' ? ctx.close : null;

    if (msg === 'HTTP_400' && (code === 'forbidden_for_part' || detail === 'forbidden_for_part')) {
      if (close) close();
      if (typeof cbs.onRefresh === 'function') cbs.onRefresh();
      if (showError) showError(t('pickup_date_error_forbidden_for_part') || '');
      if (typeof cbs.onForbiddenForPart === 'function') {
        setTimeout(function () {
          cbs.onForbiddenForPart();
        }, 0);
      }
      return;
    }
    if (code === 'invalid_payload' || msg === 'HTTP_400') {
      if (showError) showError(t('pickup_date_error_invalid_date') || 'Date invalide.');
      return;
    }
    if (msg === 'HTTP_422' || detail === 'wrong_status') {
      if (showError) showError(t('pickup_date_error_wrong_status') || '');
      return;
    }
    if (msg === 'HTTP_429') {
      if (showError) showError(t('pickup_date_error_rate_limit') || 'Trop de tentatives. Réessayez plus tard.');
      return;
    }
    if (msg === 'HTTP_409' || detail === 'stale_data') {
      if (close) close();
      if (typeof cbs.onRefresh === 'function') cbs.onRefresh();
      if (typeof cbs.onStaleData === 'function') cbs.onStaleData();
      return;
    }
    if (showError) showError(t('modal_pickup_date_save_error') || 'Une erreur est survenue.');
  }

  // Libellé localisé d'un créneau de retrait (matin / après-midi) — fallback FR.
  function formatPickupSlot(slot) {
    if (slot === 'matin') return t('pickup_slot_morning') || 'Matin';
    if (slot === 'apremidi') return t('pickup_slot_afternoon') || 'Après-midi';
    return '';
  }

  window.buybackPortalHelpers = {
    computeStateFromSlug: computeStateFromSlug,
    computeStateFromTimeline: computeStateFromTimeline,
    normalizeStepLabel: normalizeStepLabel,
    resolveCurrentStepLabel: resolveCurrentStepLabel,
    renderProgress: renderProgress,
    renderOffer: renderOffer,
    renderOfferCardSelection: renderOfferCardSelection,
    renderStepMessage: renderStepMessage,
    parseStores: parseStores,
    hasStoreChosen: hasStoreChosen,
    lookupStore: lookupStore,
    lookupStoreName: lookupStoreName,
    getMotifLabel: getMotifLabel,
    MINT_DIRECT_STORE_ID: MINT_DIRECT_STORE_ID,
    NO_STORE_NEARBY_STORE_ID: NO_STORE_NEARBY_STORE_ID,
    isMintDirectStore: isMintDirectStore,
    isNoStoreNearby: isNoStoreNearby,
    normalizeVendorType: normalizeVendorType,
    isPart: isPart,
    handlePickupDateError: handlePickupDateError,
    formatPickupSlot: formatPickupSlot,
  };
})(window, document);
